import {
  essityCatalogTranslationsModule,
  essityCatalogOverridesModule,
  essityApiDocsOverridesModule,
  essityCatalogGraphOverridesModule,
  essityScaffolderOverridesModule,
  essityApiValidationReportModule,
  essityAiModelCardModule,
} from './modules';

export const essityCatalogPlugin = [
  essityCatalogTranslationsModule,
  essityCatalogOverridesModule,
  essityApiDocsOverridesModule,
  essityCatalogGraphOverridesModule,
  essityScaffolderOverridesModule,
  essityApiValidationReportModule,
  essityAiModelCardModule,
];
